import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home", end: true },
  { to: "/coaching", label: "Coaching" },
  { to: "/community", label: "Community" },
  { to: "/about", label: "About" },
  { to: "/journal", label: "Journal" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => setOpen(false), [loc.pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#EAE3D8]"
          : "bg-[#F7F4EF]/50 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-24 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-body text-sm tracking-wide transition-colors relative py-1 ${
                  isActive ? "text-[#47394E]" : "text-[#9C8199] hover:text-[#47394E]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/booking"
            data-testid="nav-book"
            className="ml-2 rounded-full bg-[#47394E] text-[#E8DCCF] px-6 py-2.5 text-sm font-medium hover:bg-[#B7926A] transition-colors"
          >
            Book a Session
          </NavLink>
        </nav>

        <button
          className="lg:hidden text-[#47394E]"
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-[#EAE3D8] px-6 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="font-display text-2xl text-[#47394E]"
            >
              {l.label}
            </NavLink>
          ))}
          <NavLink
            to="/booking"
            data-testid="mobile-nav-book"
            className="mt-2 rounded-full bg-[#47394E] text-[#E8DCCF] px-6 py-3 text-center font-medium"
          >
            Book a Session
          </NavLink>
        </div>
      )}
    </header>
  );
};
